import { productionGeneratorGroupColors } from './ProductionGeneratorGroupStatus';

export const sxConfig = {
  containerBox: {
    height: { xs: 'auto', md: '92%', lg: '93%' },
    bgcolor: 'grey.100',
  },
  formBox: {
    p: 1,
    backgroundColor: (theme) => theme.palette.common.white,
    overflow: 'auto',
    boxShadow: 1,
    borderRadius: 2,
    height: { xs: 'auto', md: '100%' },
  },
};

const PRODUCTION_ROW_COLORS = [
  ...Object.entries(productionGeneratorGroupColors).map(([status, color]) => ({ className: `processing-${status}`, color })),
  { className: 'datagrid-line-missingSourceList', color: '#f77777' },
  { className: 'datagrid-line-missingProdOrder', color: '#c7f2ff' },
  { className: 'datagrid-line-bg_yellow', color: '#fff9c4' },
];

const withImportant = (value) => `${value} !important`;

const getProductionGeneratorGridSx = () => {
  const sx = {
    '--DataGrid-row-selectedBackground': 'transparent',
    '--DataGrid-row-selectedHoverBackground': 'transparent',
    '& .MuiDataGrid-row--editing, & .MuiDataGrid-row--editing:hover': {
      backgroundColor: withImportant('transparent'),
      boxShadow: withImportant('none'),
    },
    '& .MuiDataGrid-cell--editing': {
      backgroundColor: withImportant('transparent'),
      boxShadow: withImportant('none'),
    },
    '& .MuiDataGrid-cell--editing .MuiInputBase-root, & .MuiDataGrid-cell--editing .MuiInputBase-input': {
      backgroundColor: withImportant('#ffffff'),
    },
    '& .MuiDataGrid-row.Mui-selected, & .MuiDataGrid-row.Mui-selected:hover': {
      backgroundColor: withImportant('transparent'),
    },
    '& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell, & .MuiDataGrid-cell.Mui-selected': {
      backgroundColor: withImportant('transparent'),
    },
  };

  PRODUCTION_ROW_COLORS.forEach(({ className, color }) => {
    const rowSelector = `& .${className}`;

    sx[`${rowSelector} .MuiDataGrid-cell`] = {
      backgroundColor: withImportant(color),
    };
    sx[`${rowSelector}.Mui-selected, ${rowSelector}.Mui-selected:hover`] = {
      backgroundColor: withImportant(color),
    };
    sx[`${rowSelector} .MuiDataGrid-cell--editing`] = {
      backgroundColor: withImportant(color),
    };
    sx[`${rowSelector}.Mui-selected .MuiDataGrid-cell, ${rowSelector} .MuiDataGrid-cell.Mui-selected`] = {
      backgroundColor: withImportant(color),
    };
  });

  return sx;
};

export const productionGeneratorGridSx = getProductionGeneratorGridSx();
